(function() {
  'use strict';

  const INACTIVITY_TIME = 2 * 60 * 1000;
  const DAILY_COOKIE_NAME = 'sh_cart_pop_seen';
  const DAILY_COOKIE_DAYS = 1;
  const COUNTDOWN_MS = 12 * 60 * 1000; // "Held for 12:00"
  // sessionStorage (not a cookie) on purpose: this is what makes the
  // timer answer Ryan's question 3. It holds the deadline for the rest
  // of THIS browser session (tab), so a refresh brings the popup back
  // with its real remaining time instead of resetting to 12:00 or, as
  // it did before, not reappearing at all. Closing the tab clears it,
  // same as the daily cookie means it won't force its way back tomorrow.
  const SESSION_DEADLINE_KEY = 'sh_cart_pop_deadline';

  const state = {
    popupShown: false,
    inactivityTimer: null,
    countdownInterval: null,
    lastActivityTime: Date.now(),
    cartChecked: false,
    hasCartItems: false,
    cartData: null
  };

  const HEADLINE_NOT_APPLIED = 'Save 30% on your order';
  const HEADLINE_APPLIED = 'Your 30% is already applied';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // True only once SAVE30 (or any discount) is actually sitting on the
  // cart - which is NOT the case the first time this popup shows, since
  // nothing has run applyDiscount() yet at that point. Checks the two
  // signals cart.json actually gives us: a lower total_price than
  // original_total_price, and the cart_level_discount_applications list
  // as a backup in case a theme/API version omits the price fields.
  function isDiscountApplied(data) {
    if (!data) return false;
    if (Array.isArray(data.cart_level_discount_applications) && data.cart_level_discount_applications.length > 0) {
      return true;
    }
    if (typeof data.original_total_price === 'number' && typeof data.total_price === 'number') {
      return data.total_price < data.original_total_price;
    }
    return false;
  }

  // Item 8: the product card and the subtotal line are both pulled from
  // the REAL cart every time this runs - nothing is hardcoded to one
  // product. The card shows whichever line item is worth the most (its
  // own image/title/price); the subtotal line only appears when there's
  // more than one line item, so a single-item cart just shows that one
  // item and nothing else needs explaining underneath it.
  function renderCartSummary(data) {
    const popup = document.getElementById('exit-popup');
    if (!popup || !data || !data.items || !data.items.length) return;

    let top = data.items[0];
    for (let i = 1; i < data.items.length; i++) {
      if (data.items[i].line_price > top.line_price) top = data.items[i];
    }

    const nameEl = popup.querySelector('[data-popup-item-name]');
    const imgEl = popup.querySelector('[data-popup-item-img]');
    const wasEl = popup.querySelector('[data-popup-was]');
    const nowEl = popup.querySelector('[data-popup-now]');
    const subtotalEl = popup.querySelector('[data-popup-subtotal]');
    const headlineEl = popup.querySelector('[data-popup-headline]');

    if (headlineEl) {
      headlineEl.textContent = isDiscountApplied(data) ? HEADLINE_APPLIED : HEADLINE_NOT_APPLIED;
    }

    if (nameEl) {
      nameEl.textContent = top.product_title || top.title || 'Your order';
    }
    if (imgEl) {
      imgEl.innerHTML = top.image
        ? '<img src="' + top.image + '" alt="' + (top.product_title || '') + '">'
        : '';
    }

    const itemWas = top.original_line_price || top.line_price;
    const itemNow = Math.round(itemWas * 0.7);
    if (wasEl) wasEl.textContent = formatMoney(itemWas);
    if (nowEl) nowEl.textContent = formatMoney(itemNow);

    if (subtotalEl) {
      if (data.items.length > 1) {
        const cartWas = data.total_price;
        const cartNow = Math.round(cartWas * 0.7);
        subtotalEl.textContent = 'Cart subtotal: ' + formatMoney(cartWas) + ' → ' + formatMoney(cartNow);
        subtotalEl.hidden = false;
      } else {
        subtotalEl.hidden = true;
        subtotalEl.textContent = '';
      }
    }
  }

  // resumeDeadline lets init() re-open the popup after a refresh with the
  // SAME deadline it already had, instead of granting a fresh 12:00.
  function startCountdown(resumeDeadline) {
    const el = document.querySelector('#exit-popup [data-popup-timer]');
    if (!el) return;

    const deadline = resumeDeadline || (Date.now() + COUNTDOWN_MS);
    try { sessionStorage.setItem(SESSION_DEADLINE_KEY, String(deadline)); } catch (e) {}

    function render() {
      const remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      const m = Math.floor(remaining / 60);
      const s = remaining % 60;
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (remaining <= 0 && state.countdownInterval) {
        clearInterval(state.countdownInterval);
      }
    }

    render();
    if (state.countdownInterval) clearInterval(state.countdownInterval);
    state.countdownInterval = setInterval(render, 1000);
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getResumeDeadline() {
    try {
      const stored = sessionStorage.getItem(SESSION_DEADLINE_KEY);
      if (!stored) return null;
      const deadline = parseInt(stored, 10);
      return deadline > Date.now() ? deadline : null;
    } catch (e) {
      return null;
    }
  }

  function init() {
    const resumeDeadline = getResumeDeadline();

    if (resumeDeadline) {
      // The popup was open (or had been shown this session and not
      // dismissed) when the page reloaded - bring it straight back with
      // its real remaining time instead of losing the countdown.
      checkCartItems(function() {
        if (state.hasCartItems) showPopup('resumed', resumeDeadline);
      });
      return;
    }

    // Already shown once today (any page) - don't even fetch the cart or
    // set up the inactivity timer. This is the fix for the "keeps
    // reappearing" issue: the old logic had no cross-page-load memory at
    // all, so it could re-trigger every ~2 minutes on every single page
    // view during a session. Now capped to once per 24 hours, full stop.
    if (getCookie(DAILY_COOKIE_NAME)) {
      console.log('Cart-abandonment popup already shown today - skipping');
      return;
    }
    checkCartItems();
  }

  function checkCartItems(onDone) {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        if (data.items && data.items.length > 0) {
          console.log('Cart has ' + data.items.length + ' items');
          state.hasCartItems = true;
          state.cartChecked = true;
          state.cartData = data;
          setupInactivityTracking();
          startInactivityTimer();
          checkCheckoutReturn();
          if (window.gtag) {
            gtag('event', 'cart_abandoned_popup_active', {
              event_category: 'cart_abandonment',
              items_in_cart: data.items.length,
              cart_total: data.total_price
            });
          }
        } else {
          console.log('Cart is empty - popup will not show');
          state.cartChecked = true;
        }
        trackPageView();
        if (typeof onDone === 'function') onDone();
      })
      .catch(error => {
        console.log('Error checking cart:', error);
        state.cartChecked = true;
        if (typeof onDone === 'function') onDone();
      });
  }

  function checkCheckoutReturn() {
    const referrer = document.referrer || '';
    if ((referrer.includes('/checkout') || referrer.includes('/cart')) && state.hasCartItems) {
      console.log('User came back from checkout with items in cart');
      if (!state.popupShown) {
        showPopup('checkout_return');
      }
    }
  }

  function setupInactivityTracking() {
    document.addEventListener('mousemove', resetInactivityTimer);
    document.addEventListener('keypress', resetInactivityTimer);
    document.addEventListener('click', resetInactivityTimer);
    document.addEventListener('scroll', resetInactivityTimer);
    document.addEventListener('touchstart', resetInactivityTimer);
    document.addEventListener('touchmove', resetInactivityTimer);
  }

  function resetInactivityTimer() {
    state.lastActivityTime = Date.now();
    if (state.popupShown) return;
    if (!state.hasCartItems) return;
    if (state.inactivityTimer) clearTimeout(state.inactivityTimer);
    startInactivityTimer();
  }

  function startInactivityTimer() {
    if (state.inactivityTimer) clearTimeout(state.inactivityTimer);
    state.inactivityTimer = setTimeout(function() {
      const timeSinceLastActivity = Date.now() - state.lastActivityTime;
      if (timeSinceLastActivity >= INACTIVITY_TIME && state.hasCartItems) {
        console.log('User inactive for 2 minutes with items in cart - showing popup');
        if (!state.popupShown) {
          showPopup('inactivity');
        }
      }
    }, INACTIVITY_TIME);
  }

  function showPopup(trigger, resumeDeadline) {
    // Already-shown-today guard repeated here defensively (checkCheckoutReturn
    // and the inactivity timer both call showPopup directly) so nothing can
    // slip past init()'s check via a different code path. Not applied when
    // resuming after a refresh, since that's the SAME showing continuing,
    // not a new one.
    if (!resumeDeadline && getCookie(DAILY_COOKIE_NAME)) return;

    const popup = document.getElementById('exit-popup');
    if (popup) {
      renderCartSummary(state.cartData);
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      state.popupShown = true;
      startCountdown(resumeDeadline);
      setCookie(DAILY_COOKIE_NAME, '1', DAILY_COOKIE_DAYS); // mark "shown today" the moment it appears
      if (window.gtag) {
        gtag('event', 'abandonment_popup_shown', {
          event_category: 'cart_abandonment',
          event_label: trigger,
          trigger_type: trigger,
          discount_type: '30_percent'
        });
      }
    }
  }

  window.closePopup = function() {
    const popup = document.getElementById('exit-popup');
    if (popup) {
      popup.style.display = 'none';
      document.body.style.overflow = 'auto';
      if (state.countdownInterval) clearInterval(state.countdownInterval);
      try { sessionStorage.removeItem(SESSION_DEADLINE_KEY); } catch (e) {}
      if (window.gtag) {
        gtag('event', 'abandonment_popup_closed', {
          event_category: 'cart_abandonment',
          event_label: 'user_closed'
        });
      }
      // NOTE: state.popupShown intentionally stays true, and the daily
      // cookie stays set - closing no longer re-arms the timer for another
      // shot later today. That's the whole point of the fix.
    }
  };

  window.applyDiscount = function(code) {
    if (window.gtag) {
      gtag('event', 'abandonment_popup_discount_applied', {
        event_category: 'cart_abandonment',
        event_label: code,
        discount_percent: 30
      });
    }
    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
  };

  function trackPageView() {
    if (window.gtag) {
      gtag('event', 'page_view', {
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();